// src/pages/Exam/StatusDialog.jsx
import React, {useMemo} from "react";
import {Dialog} from "primereact/dialog";
import {useExam} from "../../contexts/ExamContext";
import {Divider} from "primereact/divider";

const pad2 = (n) => String(n).padStart(2, "0");
const formatClock = (d) => `${pad2(d.getHours())}:${pad2(d.getMinutes())}:${pad2(d.getSeconds())}`;
const formatDuration = (sec) => {
    const s = Math.max(0, Math.floor(sec));
    const h = Math.floor(s / 3600);
    const m = Math.floor((s % 3600) / 60);
    const r = s % 60;
    return h > 0 ? `${h}:${pad2(m)}:${pad2(r)}` : `${m}:${pad2(r)}`;
};

const StatusDialog = ({visible, onHide, exam, startedAt, timeLeft, appendTo}) => {
    const {answers, questions = []} = useExam();

    const stats = useMemo(() => {
        const total = questions?.length ?? 0;
        const answered = Object.keys(answers ?? {}).length;
        const remaining = Math.max(0, total - answered);
        const durationSec = Math.max(0, (exam?.durationMinutes ?? 0) * 60);
        const remainingSec = Math.max(0, timeLeft ?? 0);
        const elapsed = Math.max(0, durationSec - remainingSec);
        const avgPerQ = answered > 0 ? elapsed / answered : 0;
        const start = startedAt ?? new Date();
        const endAt = new Date(start.getTime() + durationSec * 1000);
        return { total, answered, remaining, durationSec, elapsed, remainingSec, startedAt: start, endAt, avgPerQ };
    }, [exam, answers, startedAt, timeLeft, questions]);

    const tableStyle = {width: "100%", borderCollapse: "collapse"};
    const thClass = "border-1 surface-border p-2 w-3 font-medium text-800 surface-100";
    const tdClass = "border-1 surface-border p-2 text-xl font-bold";

    return (
        <Dialog header="Anlık Durum" visible={visible} style={{width: "50vw"}} modal onHide={onHide}
                appendTo={appendTo}>
            <div className="p-3">
                <div className="mb-4">
                    <h5 className="mt-0 mb-2">Test Bilgileri</h5>
                    <table style={tableStyle}>
                        <thead>
                        <tr>
                            <th className={thClass}>Test Adı</th>
                            <th className={thClass}>Toplam Soru sayısı</th>
                            <th className={thClass}>Cevaplanan Soru Sayısı</th>
                            <th className={thClass}>Kalan Soru Sayısı</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td className={tdClass}>{exam?.title ?? "-"}</td>
                            <td className={tdClass}>{stats.total}</td>
                            <td className={tdClass}>{stats.answered}</td>
                            <td className={tdClass}>{stats.remaining}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <Divider className="my-3"/>
                <div>
                    <h5 className="mt-0 mb-2">Anlık Süre Bilgileri</h5>
                    <table style={tableStyle}>
                        <thead>
                            <tr>
                                <th className={thClass}>Başlama saati</th>
                                <th className={thClass}>Bitiş saati</th>
                                <th className={thClass}>Sınav süresi</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className={tdClass}>{formatClock(stats.startedAt)}</td>
                                <td className={tdClass}>{formatClock(stats.endAt)}</td>
                                <td className={tdClass}>{formatDuration(stats.durationSec)}</td>
                            </tr>
                        </tbody>

                        <thead>
                            <tr>
                                <th className={thClass}>Geçen süre</th>
                                <th className={thClass}>Kalan süre</th>
                                <th className={thClass}>Soru başına ortalama süre</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className={tdClass}>{formatDuration(stats.elapsed)}</td>
                                <td className={tdClass}>{formatDuration(stats.remainingSec)}</td>
                                <td className={tdClass}>{stats.answered  ? formatDuration(stats.avgPerQ) : "-"}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </Dialog>
    );
};

export default StatusDialog;